<template>
  <div class="digital-save-button" :style="{ top: top + 'px', bottom: bottom + 'px', left: left + 'px', right: right + 'px' }">
    <div class="box">
      <div class="page">
        <span class="prev" @click="prev()" :class="{ disabled: this.pageIndex === 1 }">上一页</span>
        <span class="text">第 {{ pageIndex }} / {{ pageTotal }} 页</span>
        <span class="next" @click="next()" :class="{ disabled: this.pageIndex === this.pageTotal }">下一页</span>
      </div>
      <div class="save" @click="save">保存</div>
      <div class="save-exit" @click="saveAndExit">保存并退出</div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'DigitalSaveButton',
  components: {},
  props: {
    top: {
      type: [Number, String],
      default: null
    },
    bottom: {
      type: [Number, String],
      default: 22
    },
    left: {
      type: [Number, String],
      default: 360
    },
    right: {
      type: [Number, String],
      default: 460
    },
    initPageIndex: {
      type: Number,
      default: 0
    },
    initPageTotal: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      pageIndex: this.initPageIndex,
      pageTotal: this.initPageTotal
    }
  },
  watch: {
    initPageIndex(pageIndex) {
      this.pageIndex = pageIndex
    },
    initPageTotal(pageTotal) {
      this.pageTotal = pageTotal
    }
  },
  computed: {
    ...mapState('book'),
    isPaper() {
      return this.$route.query.type === 'paper'
    }
  },
  mounted() {},
  methods: {
    prev() {
      if (this.pageIndex <= 1) {
        return
      }
      this.pageIndex--
      this.$emit('onPrev', this.pageIndex)
    },
    next() {
      if (this.pageIndex >= this.pageTotal) {
        return
      }
      this.pageIndex++
      this.$emit('onNext', this.pageIndex)
    },
    save() {
      this.$emit('onSave', 1, this.pageIndex)
    },
    saveAndExit() {
      this.$emit('onSave', this.isPaper ? 'paper' : 'book', this.pageIndex)
    },
    recovery() {
      this.pageIndex = this.initPageIndex
    }
  }
}
</script>
<style lang="scss">
.digital-save-button {
  position: absolute;
  z-index: 90;
  .box {
    overflow: hidden;
    background: #ffffff;
    border: 1px solid #df5813;
    line-height: 40px;
    font-size: 14px;
    text-align: center;
    width: 440px;
    margin: auto;
    .page {
      float: left;
      width: 240px;
      font-size: 12px;
      .prev {
        background: #df5813;
        padding: 3px 10px;
        border-radius: 5px;
        color: #ffffff;
        cursor: pointer;
        &:hover {
          background: #c94f11;
        }
        &:active {
          background: #b34710;
        }
      }
      .text {
        margin: 0 15px;
      }
      .next {
        background: #df5813;
        padding: 3px 10px;
        border-radius: 5px;
        color: #ffffff;
        cursor: pointer;
        &:hover {
          background: #c94f11;
        }
        &:active {
          background: #b34710;
        }
      }
      .disabled {
        background: #999999;
        color: #ffffff;
        cursor: default;
        &:hover {
          background: #999999;
        }
        &:active {
          background: #999999;
        }
      }
    }
    .save {
      float: left;
      width: 99px;
      background: #df5813;
      color: #ffffff;
      cursor: pointer;
      &:hover {
        background: #c94f11;
      }
      &:active {
        background: #b34710;
      }
    }
    .save-exit {
      float: left;
      width: 99px;
      color: #df5813;
      background: #ffffff;
      cursor: pointer;
      &:hover {
        background: #f3f3f3;
      }
      &:active {
        background: #e3e3e3;
      }
    }
  }
}
</style>
